// IE Hub - Application Version Info
// Centralised, typed access to the app version for display in the UI.

import { PUBLIC_ENV } from './env';

export interface AppVersionInfo {
  readonly version: string;
}

export const APP_VERSION_INFO: AppVersionInfo = {
  version: PUBLIC_ENV.appVersion,
};
